module.exports = __webpack_public_path__ + "static/media/big_mobileapp.3a37c6ef.svg";